module.exports = __webpack_public_path__ + "static/reg-large17-0523a864c6efd04a4f5ccc4aadbf216b.jpg";